import { App as AntdApp } from 'antd';
import dayjs from 'dayjs';
import { useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './App.scss';
import urlPath from './constants/urlPath/urlPath';
import { AppContext } from './contexts/app.context';
import useRouteElements from './hooks/useRouteElements';

import { useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';
import 'dayjs/locale/vi';
import { getUserResourceFullAccess } from './apis/master_data/userResource.api';
import type { IResourceFullAccessDetail, IUserResourceFullAccess } from './types/master_data/userResource.type';
import { getAccessTokenFromLS } from '@martech-solution/utils/utils';
dayjs.locale('vi');

function App() {
  const { resources, setResources, setUserInfo, resourcePermissionLoading, setResourcePermissionLoading } =
    useContext(AppContext);

  const routeElements = useRouteElements(resources as IResourceFullAccessDetail[], !!resourcePermissionLoading);
  const location = useLocation();
  const isHomePage = location.pathname === urlPath.home.location || location.pathname === urlPath.systemAdmin.location;
  const token = getAccessTokenFromLS();

  const { isFetching: resourcePermissionFetching } = useQuery({
    queryKey: ['userAccessResource', token],
    queryFn: async () => await getUserResourceFullAccess(),
    staleTime: 60 * 1000 * 10,
    enabled: !!token,
    onSuccess: (data: AxiosResponse<IUserResourceFullAccess, any>) => {
      // Set Resource
      let _resourcePermissions: IResourceFullAccessDetail[] = [];
      // Kiểm tra trùng path thì gộp quyền lại
      data.data?.details?.forEach(({ path, permissions, hrTicketCategoryCode, name }) => {
        if (!!path) {
          let pathRoots = path?.split(',');
          pathRoots?.forEach((pathString) => {
            const index = _resourcePermissions?.findIndex((x) => x.path === pathString);
            if (index === -1) {
              _resourcePermissions.push({ path: pathString, permissions: permissions, name, hrTicketCategoryCode });
            } else {
              _resourcePermissions[index] = {
                path: pathString,
                name,
                hrTicketCategoryCode,
                permissions: [...(_resourcePermissions[index] || [])?.permissions, ...permissions]
              };
            }
          });
        }
      });
      setResources(_resourcePermissions);

      // Set User Info
      if (data.data.employee) {
        setUserInfo(data.data.employee);
        localStorage.setItem('userInfo', JSON.stringify(data.data.employee));
      }
    }
  });

  useEffect(() => {
    setResourcePermissionLoading(resourcePermissionFetching);
  }, [resourcePermissionFetching, setResourcePermissionLoading]);

  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
        navigator.serviceWorker.controller.postMessage({
          type: 'CHECK_VERSION_AND_CLEAR_CACHE',
          data: {}
        });
      }
    }
  }, []);

  return (
    <div className={`app-container ${isHomePage ? 'home' : ''} `}>
      <AntdApp>{routeElements}</AntdApp>
    </div>
  );
}

export default App;
